// 24.08.27 중국 은행 목록 변경
// - Bank of China 中国銀行 중국은행
// - Industrial and Commercial Bank of China Limited 中国工商银行 중국공상은행
// - Hua Xia Bank 华夏银行 화하은행
// - Agriculture Bank of China 中国农业银行 중국농업은행
// - China Construction Bank 中国建设银行 중국건설은행
export const CHN_BANK_LIST = [
  '中国银行 BOC',
  '中国工商银行 ICBC',
  '华夏银行 HXB',
  '中国农业银行 ABC',
  '中国建设银行 CCB',
  // '交通银行 BOCOM',
  // '光大银行 CEB',
  // '上海银行 SHB',
  // '临商银行 LSB',
];

export const CHN_BANK_TRADITION_LIST = [
  '中國銀行 BOC',
  '中國工商銀行 ICBC',
  '華夏銀行 HXB',
  '中國農業銀行 ABC',
  '中國建設銀行 CCB',
  // '交通銀行 BOCOM',
  // '光大銀行 CEB',
  // '上海銀行 SHB',
  // '臨商銀行 LSB',
];

export const CHN_BANK_ABBREVIATION_LIST = [
  'BOC',
  'ICBC',
  'HXB',
  'ABC',
  'CCB',
  // 'BOCOM',
  // 'CEB',
  // 'SHB',
  // 'LSB',
];
